import { ButtonLink } from "@/components/lib/ButtonLink";
import { Row, Col } from "react-bootstrap";
import { CompanyListTable } from "@/components/entities/company/CompanyListTable";
import { useUserRole } from "@/hooks/useUserRole";
import React from "react";
import { useOutletContext } from "react-router-dom";

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

export const CompanyList = () => {
  const { setTitle } = useOutletContext<ContextType>()
  const myRole = useUserRole();

  React.useEffect(() => {
    setTitle('Sociétés')
  }, [setTitle])

  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col className="d-flex justify-content-end">
          {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
            <ButtonLink
              name={"Nouvelle société"}
              href={"/societes/creation"}
              icon={"Plus"}
            />
          )}
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <CompanyListTable />
        </Col>
      </Row>
    </>
  );
};
